var CATCH_SELLER_ID = "1";
export var isSoldByCatch = function isSoldByCatch(sellerId) {
  return sellerId == CATCH_SELLER_ID;
};